gsap.registerPlugin(ScrollTrigger);

// Create a GSAP matchMedia instance
let mm = gsap.matchMedia();

mm.add("(min-width: 768px)", () => {
  // Animation for screens larger than or equal to 768px
  gsap.to(".butterfly-img", {
    scrollTrigger: {
      trigger: ".butterfly-img",
      start: "top 1000px",
      end: "top 100px",
      scrub: true,
      // markers: true
    },
    x: -400,
    ease: "none",
    duration: 5
  });
});

mm.add("(max-width: 767px)", () => {
  // Animation for screens smaller than 768px
  gsap.to(".butterfly-img", {
    scrollTrigger: {
      trigger: ".butterfly-img",
      start: "top 1000px",
      end: "top 100px",
      scrub: true,
      // markers: true
    },
    x: -300,
    ease: "none",
    duration: 5
  });
});

$(document).ready(function () {
   // View more button
function toggleDescription() {
        var descriptionContent = $('#descriptionContent');
        var viewMoreBtn = $('#viewMoreBtn');
        // Toggle the expanded class
        descriptionContent.toggleClass('expanded');
        // Change button text based on state
        if (descriptionContent.hasClass('expanded')) {
            viewMoreBtn.text('View Less');
        } else {
            viewMoreBtn.text('View More');
        }
    }
    // Attach the toggle function to the button click event
    $('#viewMoreBtn').on('click', toggleDescription);





//   $('.testimonial-sec .multicolumn-list').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
  $('.owner-fav-products .product-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
  ]
});

$('.mini-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  

});







